import { Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';
import { FlatList, FlatListProps } from 'react-native';

export interface AssetsListProps<T> {
  id: string;
  data: T[];
  columns: number;
  rows?: number;
  renderItem: FlatListProps<T>['renderItem'];
  keyExtractor: FlatListProps<T>['keyExtractor'];
}

export const AssetsList = <T,>({
  id,
  columns,
  data,
  rows = 1,
  renderItem,
  keyExtractor,
}: AssetsListProps<T>) => {
  return (
    <FlatList
      key={id}
      style={{ overflow: 'visible' }}
      keyExtractor={keyExtractor}
      columnWrapperStyle={{
        justifyContent: rows === 1 ? 'space-between' : undefined,
        paddingVertical: Utils.Token.ToInt(Spacing, 'stack.nano'),
      }}
      data={data}
      renderItem={renderItem}
      numColumns={columns}
    />
  );
};
